export default "__VITE_ASSET__a254178b__"